import React from 'react';

import { Header } from 'semantic-ui-react'
import { ResponsivePie } from '@nivo/pie'

import { schemeSet2 } from 'd3-scale-chromatic';

const pieToolTip = (props) => {

  return (<div style={{ minWidth: '100px'}}>
    <p>{props.id}</p>
    <p>{(props.value * 100).toFixed(2)}%</p>
  </div>)
}

const PieRow = (props) => {
  const legends = [
    {
      "anchor": "top-right",
      "direction": "column",
      "justify": false,
      "translateY": 70,
      "translateX": 150,
      "itemsSpacing": 0,
      "itemDirection": "left-to-right",
      "itemWidth": 95,
      "itemHeight": 20,
      "itemOpacity": 0.75,
      "symbolSize": 12,
      "symbolShape": "square",
      "symbolBorderColor": "rgba(0, 0, 0, .5)",
    }
  ];

  const chartConfig = {
    margin: {
      "top": -70,
      "right": 210,
      "bottom": 180,
      "left": 20
    },
    tooltip: pieToolTip,
    width: 340,
    height: 400,
    enableSlicesLabels: false,
    sliceLabel: 'id',
    enableRadialLabels: false,
    // Motion details
    innerRadius: 0.5,
    padAngle: 0.7,
    cornerRadius: 3,
    colors: schemeSet2,
    colorBy: "id",
    borderWidth: 1,
    borderColor: "inherit:darker(0.2)",
    sortByValue: true,
    animate: true,
    motionStiffness: 90,
    motionDamping: 15,
  }

  const leftRightMargin = 230;
  const right = 180;
  const startChartConfig = {
    ...chartConfig,
    margin: {
      "top": -70,// position them similarly
      "right": right,
      "bottom": 180,
      "left": leftRightMargin - right,
    },
    data: props.startData,
  }

  const endChartConfig = {
    ...chartConfig,
    data: props.endData,
  }

  if (props.hasLegend) {
    endChartConfig['legends'] = legends;
  }

  return (
    // Responsive line requires parent to have height
    <div style={{ height: '220px', marginLeft: '-120px' }}>
      <Header as='h4'>{props.title}</Header>
      <div style={{ width: '220px', height: '300px', display: 'inline-block' }}>
        <p style={{ marginLeft: '-14px' }}>{props.startTitle}</p>
        <ResponsivePie {...startChartConfig} />
      </div>
      <div style={{ width: '220px', height: '300px', display: 'inline-block' }}>
      <p style={{ marginLeft: '-80px' }}>{props.endTitle}</p>
        <ResponsivePie {...endChartConfig} />
      </div>
    </div>
  );
}

export default PieRow;



// WEBPACK FOOTER //
// ./src/components/pieRow/index.js